const DEFAULTS = Object.freeze({
  enabled: false,
  apiBase: '/api/v1',
  publicApiBase: '/api/public',
  uploadPartBytes: 8 * 1024 * 1024,
  uploadConcurrency: 2,
  pollIntervalMs: 2500,
});

function normalizeBase(value, fallback) {
  const base = String(value || fallback).trim().replace(/\/+$/, '');
  return base || fallback;
}

function positiveInteger(value, fallback) {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

export function getCloudConfig() {
  const runtime =
    typeof window !== 'undefined' && window.__VR_TOUR_CLOUD__ && typeof window.__VR_TOUR_CLOUD__ === 'object'
      ? window.__VR_TOUR_CLOUD__
      : {};

  return {
    enabled: runtime.enabled === true,
    apiBase: normalizeBase(runtime.apiBase, DEFAULTS.apiBase),
    publicApiBase: normalizeBase(runtime.publicApiBase, DEFAULTS.publicApiBase),
    uploadPartBytes: positiveInteger(runtime.uploadPartBytes, DEFAULTS.uploadPartBytes),
    uploadConcurrency: Math.min(2, positiveInteger(runtime.uploadConcurrency, DEFAULTS.uploadConcurrency)),
    pollIntervalMs: positiveInteger(runtime.pollIntervalMs, DEFAULTS.pollIntervalMs),
  };
}

export function publicTourIdFromPath(pathname = '') {
  const match = /^\/t\/([^/?#]+)\/?$/i.exec(pathname);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
}
